import api from "./apiBase";

function loginUser(email, password) {
  return api.post("/auth/login", { email, password });
}

function getUser() {
  return api.get("/auth/me");
}

function getCodeOTP() {
  return api.get("/email-verification");
}

function verifyCodeOTP(code) {
  return api.post("/email-verification", { code });
}

function verifyEmailAvailable(email) {
  return api.get("/auth/verify?email=" + email);
}

function verifyUsernameAvailable(username) {
  return api.get("/auth/verify?username=" + username);
}

function resetPassword(email) {
  return api.post("/auth/reset-password", { email })
}

function validateResetPassword(query) {
  return api.get(`/auth/reset/validate?q=${query}`)
}

function redefinePassword(token, payload) {
  return api.patch('auth/password/new', payload, {
    headers: {
      'Content-Type': 'application/json',
      'x-mm-token': token
    }
  })
}

export {
  loginUser,
  getUser,
  getCodeOTP,
  verifyCodeOTP,
  verifyEmailAvailable,
  verifyUsernameAvailable,
  resetPassword,
  validateResetPassword,
  redefinePassword
}